import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FastField } from 'formik';
import { withNamespaces } from 'react-i18next';
import TextFieldInput from '../../Global/Inputs/TextField';
import OutlinedSelectInput from '../../Global/Inputs/OutlinedSelect';

import TableRateDetailsStyles from './TableRateDetails.styles';
import SpacingStyles from '../../../styles/helpers/spacing';
import combineStyles from './../../../utils/combineStyles';

export const TableRateDetails = props => {
  const {
    t,
    classes,
    handleChange,
    values,
    context,
    handleValidateField
  } = props;
  const { lcpExceptions } = context.globalProps.orgRefs;
  return (
    <div className={classes.root}>
      <div className={classes.verticalGridItem}>
        <FastField
          name="lcpExceptionReasonId"
          onChange={handleChange}
          render={({ field, form }) => {
            return (
              <OutlinedSelectInput
                value={values['lcpExceptionReasonId']}
                field={field}
                form={form}
                label={t('LCP Exception Reason')}
                options={lcpExceptions}
                multiple={false}
                validateField={handleValidateField}
              />
            );
          }}
        />
      </div>
      <div className={classes.verticalGridItem}>
        <FastField
          value={values.lcpExceptionReasonNotes}
          name={'lcpExceptionReasonNotes'}
          label={t('Notes')}
          onChange={handleChange}
          component={TextFieldInput}
        />
      </div>
    </div>
  );
};

const TableRateDetailsWithTranslations = withNamespaces()(TableRateDetails);
export default withStyles(combineStyles(TableRateDetailsStyles, SpacingStyles))(
  TableRateDetailsWithTranslations
);
